/* eslint
no-debugger: 0
 */
import CustomSlider from '../autoload/CustomSlider'
require('slick-carousel')

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {

    $(document).ready( function ( $ ) {
      // keyboard
      $('nav > ul').on( 'focus.wparia', '[aria-haspopup="true"]', function (event) {
        $(event.currentTarget).attr( 'aria-expanded', true );
      });

      $('nav > ul').on( 'blur.wparia', '[aria-haspopup="true"]', function(event) {
        $(event.currentTarget).attr( 'aria-expanded', false );
      });
    });

    // open or close elements
    $('[data-toggle]').on('click', function(event) {
      const $el = $(event.delegateTarget)
      const state = $el.attr('aria-expanded')
      const target = $($el.attr('data-toggle'))
      $el.attr('aria-expanded', state === 'true' && 'false' || 'true')
      target.toggleClass('active')
    })

    const $menu = $('#nav-primary')
    const $els = $('#nav-primary [tabindex]:not(.menu-item-has-children)')
    $menu.on('click', function() {
      const index = $menu.hasClass('active') ? 0 : -1
      $els.attr('tabIndex', index)
    })

    window.customSlider = new CustomSlider()

    window.onload = function() {
      if(/iP(hone|ad)/.test(window.navigator.userAgent)) {
        document.body.addEventListener('touchstart', function() {}, false);
      }
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js